export const BRANCH_MASTER_ADD_REQUEST = "BRANCH_MASTER_ADD_REQUEST";
export const BRANCH_MASTER_ADD_SUCCESS = "BRANCH_MASTER_ADD_SUCCESS";
export const BRANCH_MASTER_ADD_ERR = "BRANCH_MASTER_ADD_ERR";

export const BRANCH_MASTER_FIND_REQUEST = "BRANCH_MASTER_FIND_REQUEST";
export const BRANCH_MASTER_FIND_SUCCESS = "BRANCH_MASTER_FIND_SUCCESS";
export const BRANCH_MASTER_FIND_ERR = "BRANCH_MASTER_FIND_ERR";

export const BRANCH_MASTER_DELETE_REQUEST = "BRANCH_MASTER_DELETE_REQUEST";
export const BRANCH_MASTER_DELETE_SUCCESS = "BRANCH_MASTER_DELETE_SUCCESS";
export const BRANCH_MASTER_DELETE_ERR = "BRANCH_MASTER_DELETE_ERR";

export const BRANCH_MASTER_EDIT_REQUEST = "BRANCH_MASTER_EDIT_REQUEST";
export const BRANCH_MASTER_EDIT_SUCCESS = "BRANCH_MASTER_EDIT_SUCCESS";
export const BRANCH_MASTER_EDIT_ERR = "BRANCH_MASTER_EDIT_ERR";
